import React, { FC } from "react";
import { Block, TExtendedBlockProps } from "kanopi-components/Block";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export const HighlightRectangle: FC<TExtendedBlockProps> = ({
  children,
  backgroundColor,
  color,
  ...props
}) => {
  const [, theme] = useStyletron();
  return (
    <Block
      margin="0 auto"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      position="relative"
      minHeight={theme.sizing.scale2400}
      $style={{
        textAlign: "center",
        boxSizing: "border-box",
      }}
      {...props}
    >
      <Block
        borderRadius={theme.sizing.scale400}
        backgroundColor={backgroundColor}
        padding={`${theme.sizing.scale400} ${theme.sizing.scale1600}`}
        color={color || theme.colors.primary}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        {children}
      </Block>
    </Block>
  );
};
